import { render, staticRenderFns } from "./MarketingList.vue?vue&type=template&id=3f8291a6"
import script from "./MarketingList.vue?vue&type=script&lang=js"
export * from "./MarketingList.vue?vue&type=script&lang=js"
import style0 from "./MarketingList.vue?vue&type=style&index=0&id=3f8291a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports